module.exports = __webpack_public_path__ + "img/rule4.7f7ca2ee.png";